import React from 'react';
import { CognitoUserProvider } from '../contexts/cognitoUserContext';
import { StripeProvider } from '../contexts/stripeContext';
import AuthManager from '../components/auth/AuthManager';

/**
 * AuthProvider - Consolidates all authentication and payment-related context providers
 * Includes: Custom AuthManager (replaces Amplify Authenticator), Cognito User, Stripe
 */
export function AuthProvider({ children }) {
  return (
    <CognitoUserProvider>
      <AuthManager>
        <StripeProvider>
          {children}
        </StripeProvider>
      </AuthManager>
    </CognitoUserProvider>
  );
}
